import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api/schools';

const apiFindLoggedSchool = async ()=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const SchoolRepository = {
  find: apiFindLoggedSchool
};